<div class="component-main-container">
  <app-page-header parentTitle="{{ 'circuit-box.parentTitle' | translate }}"
    pageTitle="{{ 'circuit-box.pageTitle'| translate }}">
  </app-page-header>

  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <app-register-form></app-register-form>

        <div class="form-fields-box" [ngClass]="!register ? 'closed' : ''" [formGroup]="registerCircuitBoxForm">
          <h2 (click)="registerBox()">
            {{ "circuit-box.form-register-label" | translate }}
          </h2>
          <hr [ngClass]="!register ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>

            <div class="input-text">
              <p-floatlabel variant="on">
                <input pInputText fluid id="reference" formControlName="reference" [pKeyFilter]="blockSpecialCharacters"
                  [class.p-invalid]="registerCircuitBoxForm.get('reference')?.invalid && registerCircuitBoxForm.get('reference')?.touched " />
                <label for="reference"> {{ "circuit-box.form-reference" | translate }}</label>
              </p-floatlabel>
              @if (
              registerCircuitBoxForm.get('reference')?.hasError('pattern') &&
              registerCircuitBoxForm.get('reference')?.touched
              ) {
              <small class="p-error" style="color: red;">
                {{'circuit-box.special-character-error' | translate}}
              </small>
              }
            </div>
          </div>

          <!-- Campo para realizar a busca dos equipamentos tipo IPC -->
          @if (true) {
          <div class="form-step">
            <div class="circle-number"> 2 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{ "circuit-box.form-ipc" | translate }} </mat-label>
              <input matInput formControlName="searchIPC">
              <mat-icon class="component-search-icon"
                (click)="filterEquipmentBySerialNumber('searchIPC','ipc', 'register')" svgIcon="bx-search"></mat-icon>
            </mat-form-field>
          </div>
          }

          <!-- Loading -->
          @if (typeFilter == 'register' && loadingEquipmentsIPC) {
          <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
          }

          @if (equipmentTypeIPC.length > 0) {
          <div class="form-step">
            <div class="circle-number">2.1</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "circuit-box.form-ipc" | translate }}</mat-label>
              <mat-select formControlName="ipc" #value>
                @for (item of equipmentTypeIPC; track item) {
                <mat-option appearance="outline" [value]="item.id">
                  {{item.serialNumber}}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }

          <div class="form-step">
            <div class="circle-number">
              3
            </div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "circuit-box.form-gateway" | translate }}</mat-label>
              <mat-select formControlName="gateway">
                @for (item of gatewayInstallationList; track item) {
                <mat-option appearance="outline" [value]="item.id">{{
                  item.reference }}</mat-option>
                }
                @if (gatewayInstallationList.length < 0) { <mat-option><mat-spinner
                    [diameter]="30"></mat-spinner></mat-option>
                  }
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Campo para realizar a busca de equipamentos tipo Corte -->
          @if (true) {
          <div class="form-step">
            <div class="circle-number"> 4 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{ "circuit-box.form-consumption" | translate }} </mat-label>
              <input matInput formControlName="searchCorte">
              <mat-icon class="component-search-icon"
                (click)="filterEquipmentBySerialNumber('searchCorte','corte', 'register')"
                svgIcon="bx-search"></mat-icon>
            </mat-form-field>
          </div>
          }

          <!-- Loading -->
          @if (typeFilter == 'register' && loadingEquipmentsCORTE) {
          <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
          }

          @if (equipmentTypeCorte.length > 0) {
          <div class="form-step">
            <div class="circle-number">4.1</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "circuit-box.form-consumption" | translate }}</mat-label>
              <mat-select formControlName="consumption" #value>
                @for (item of equipmentTypeCorte; track item) {
                <mat-option appearance="outline" [value]="item.id">
                  {{item.serialNumber}}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }


          @if (!registerLoading) {
          <button title="{{ 'circuit-box.form-save-button' | translate }}" class="btn btn-success"
            [disabled]="registerCircuitBoxForm.invalid" (click)="registerCircuitBox()">
            {{ "circuit-box.form-save-button" | translate }}
          </button>
          }
          @if (registerLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>

        <div class="form-fields-box" [ngClass]="!filter ? 'closed' : ''" [formGroup]="filterCircuitBoxForm">
          <h2 (click)="filterBox()">
            {{ "circuit-box.form-filter-label" | translate }}
          </h2>
          <hr [ngClass]="!register ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>{{ "circuit-box.form-reference" | translate }}</mat-label>
              <input matInput formControlName="reference" />
            </mat-form-field>
          </div>

          @if (!filterLoading) {
          <button title="{{ 'companies.form-save-button' | translate }}" class="btn btn-success"
            [disabled]="filterCircuitBoxForm.invalid" (click)="filterCircuitBox(null)">
            Filtrar
          </button>
          }
          @if (filterLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    @if (paginationProperties.total) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <!-- Cabeçalho da tabela -->
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')" [loadingData$]="fileLoading"
        (downloadPDF)="generateFileData(null, 'PDF')"></app-table-header>
      <div class="table-container mt-2 mt-lg-3">
        <p-table [value]="ELEMENT_DATA" [paginator]="true" dataKey="id" [rows]="pageSize" [totalRecords]="length"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="reference"> {{ "circuit-box.form-reference" | translate}}
              </th>
              <th pSortableColumn="sgIpc">IPC (Serial)</th>
              <th pSortableColumn="sgGateway">Gateway(Referência)</th>
              <th pSortableColumn="sgConsumption">Corte(Serial)</th>
              <th pSortableColumn="actions">Ações</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>
                {{row.reference}}
              </td>
              <td>{{row.sgIpcSerialNumber}}</td>
              <td>{{row.sgGatewayReference}}</td>
              <td> {{row.sgConsumptionSerialNumber}}</td>
              <<<<<<< HEAD <td>
                <!-- Botão de edição -->
                <p-button styleClass="btn-actions" [rounded]="true" icon="pi pi-pen-to-square"
                  (click)="updateGetter(row)" />
                =======
                <td on-mouseover="row.view = true" on-mouseleave="row.view = false">
                  <button (click)="updateGetter(row)" [ngClass]="row.view === true ? 'hover' : ' '"
                    class="btn btn-success view">
                    <mat-icon class="component-svg-icon" svgIcon="bx-edit"></mat-icon>
                  </button>
                  >>>>>>> 6fd8d507e6f2965c76abdcc9322642cde08b2e19
                </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    }
  </div>

  <!-- Componente de edição -->
  @if (editorController) {
  <div class="sidebar-edit" [formGroup]="updateCircuitBoxForm">
    <mat-icon (click)="closeEditionSideBar()">clear</mat-icon>
    <h2>{{ "circuit-box.form-edit-label" | translate }}</h2>
    <hr />
    <mat-form-field appearance="outline">
      <mat-label>{{ "circuit-box.form-reference" | translate }}</mat-label>
      <input matInput formControlName="reference" />
    </mat-form-field>

    <div class="input-text">
      <p-floatlabel variant="on">
        <input pInputText fluid id="reference" [pKeyFilter]="blockSpecialCharacters" formControlName="reference"
          [class.p-invalid]="updateCircuitBoxForm.get('reference')?.invalid && updateCircuitBoxForm.get('reference')?.touched " />
        <label for="reference"> {{ "circuit-box.form-reference" | translate }}</label>
      </p-floatlabel>
      @if (
      updateCircuitBoxForm.get('reference')?.hasError('pattern') &&
      updateCircuitBoxForm.get('reference')?.touched
      ) {
      <small class="p-error" style="color: red;">
        {{'circuit-box.special-character-error' | translate}}
      </small>
      }
    </div>

    <!-- Campo para realizar a busca do(s) equipamento(s) -->
    <mat-form-field appearance="outline">
      <mat-label> {{ "circuit-box.form-ipc" | translate }} </mat-label>
      <input matInput formControlName="searchUpdateIPC">
      <mat-icon class="component-search-icon" (click)="filterEquipmentBySerialNumber('searchUpdateIPC','ipc', 'update')"
        svgIcon="bx-search"></mat-icon>
    </mat-form-field>
    <!-- Loading -->
    @if (typeFilter == 'update' && loadingEquipmentsIPC) {
    <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
    }
    @if (equipmentTypeIPCUpdate.length > 0) {
    <mat-form-field appearance="outline">
      <mat-label>
        {{ "circuit-box.form-ipc" | translate }}</mat-label>
      <mat-select formControlName="sgIpcID" #value>
        @for (item of equipmentTypeIPCUpdate; track item) {
        <mat-option appearance="outline" [value]="item.id">
          {{item.serialNumber}}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    }
    <mat-form-field appearance="outline">
      <mat-label>
        {{ "circuit-box.form-gateway" | translate }}</mat-label>
      <mat-select formControlName="sgGatewayID" #value>
        @for (item of gatewayInstallationList; track item) {
        <mat-option appearance="outline" [value]="item.id">{{
          item.reference }}</mat-option>
        }
        @if (gatewayInstallationList.length < 0) { <mat-option><mat-spinner [diameter]="30"></mat-spinner></mat-option>
          }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label> {{ "circuit-box.form-consumption" | translate }} </mat-label>
      <input matInput formControlName="searchUpdateCorte">
      <mat-icon class="component-search-icon"
        (click)="filterEquipmentBySerialNumber('searchUpdateCorte','corte', 'update')" svgIcon="bx-search"></mat-icon>
    </mat-form-field>
    <!-- Loading -->
    @if (typeFilter == 'update' && loadingEquipmentsCORTE) {
    <mat-progress-bar class="mb-3" mode="indeterminate"></mat-progress-bar>
    }
    @if (equipmentTypeCorteUpdate.length > 0) {
    <mat-form-field appearance="outline">
      <mat-label>
        {{ "circuit-box.form-consumption" | translate }}</mat-label>
      <mat-select formControlName="sgConsumptionID" #value>
        @for (item of equipmentTypeCorteUpdate; track item) {
        <mat-option appearance="outline" [value]="item.id">
          {{item.serialNumber}}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    }
    @if (!updateLoading) {
    <button class="btn btn-success" (click)="updateCircuitBox()">{{"companies.form-save-button" |
      translate}}</button>
    }
    @if (updateLoading) {
    <mat-spinner [diameter]="30"></mat-spinner>
    }
  </div>
  }
</div>